"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var withContext_1 = require("../../utils/hoc/withContext");
var react_1 = require("react");
var tooltip_1 = require("../../utils/tooltip");
function withFormSectionContext(displayName, component) {
    return withContext_1.withContext(displayName, exports.FormSectionContext, 'formSection', component);
}
exports.withFormSectionContext = withFormSectionContext;
var propTypes = {
    heading: PropTypes.string,
    tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};
exports.FormSectionContext = React.createContext({ id: undefined });
var FormSectionWithinContext = /** @class */ (function (_super) {
    __extends(FormSectionWithinContext, _super);
    function FormSectionWithinContext(props) {
        var _this = _super.call(this, props) || this;
        _this.id = props.id || props.ergoElements.idGenerator.next();
        return _this;
    }
    FormSectionWithinContext.prototype.getContext = function () {
        return {
            id: this.id
        };
    };
    FormSectionWithinContext.prototype.render = function () {
        var _a = this.props, children = _a.children, heading = _a.heading, tooltip = _a.tooltip, className = _a.className, ergoElements = _a.ergoElements, other = __rest(_a, ["children", "heading", "tooltip", "className", "ergoElements"]);
        var componentClassName = classNames(className, 'ee_form-section');
        var TooltipElement = tooltip_1.default('ee_form-section__heading-tooltip', tooltip);
        var Heading = heading && (React.createElement("div", { className: "ee_form-section__heading" },
            React.createElement("h1", { className: "ee_form-section__heading-text" }, heading),
            TooltipElement));
        return (React.createElement("section", __assign({}, other, { id: this.id, className: componentClassName }),
            React.createElement(exports.FormSectionContext.Provider, { value: this.getContext() },
                Heading,
                children)));
    };
    FormSectionWithinContext.propTypes = propTypes;
    FormSectionWithinContext.defaultProps = {
        heading: undefined,
        tooltip: undefined,
        ergoElements: undefined
    };
    return FormSectionWithinContext;
}(react_1.Component));
/**
 * The `FormSection` component represents a section of a larger form.
 * In most cases, several form elements and additional description are grouped
 * together by using this component.
 *
 * In addition, a heading can be specified.
 * It is displayed above the content and is always a first level heading
 * (`h1`).
 */
exports.FormSection = withContext_1.withErgoElementsContext('FormSection', FormSectionWithinContext);
exports.default = exports.FormSection;
//# sourceMappingURL=FormSection.js.map
